// const header = {
// }

// const about = {
//   name: "Aditya Singh",
//   role: "Aspiring Software Developer",
//   description: "",
//   resume:
//     "https://drive.google.com/file/d/1RZTnn2au_hia-3xC2cqu4dUE0fz9l5Kt/view?usp=sharing",
//   social: {
//     linkedin: "https://www.linkedin.com/in/aditya-singh-97396a21a/",
//     github: "https://github.com/Aditya-devp",
//     twitter:
//       "https://twitter.com/AdityaS48654968?t=LxdOQmRtW6XlmeOOlZMFpg&s=08",
//   },
// };

// const projects = [
//   {
//     name: "Conversa",
//     description:
//       "Developed a real time  chat application with React and Socket.io, it offers instant face to face communication anytime, anywhere.",
//     stack: ["React.js", "Node.js", "Socket.io"],
//     sourceCode: "https://github.com/Aditya-devp/Conversa",
//   },
//   {
//     name: "BlogBreeze",
//     description:
//       "Developed a web app using Node.js for the anonymous submission of user secrets, ensuring a simple and friendly user interface",
//     stack: ["Node.js", "Express", "MongoDB"],
//     sourceCode: "https://github.com/Aditya-devp/BlogBreeze",
//   },
//   {
//     name: "Sortify",
//     description:
//       "Created a JavaScript application visualizing key sorting algorithms through animated simulations on randomized data, optimizing user comprehension and interaction.",
//     stack: ["HTML", "CSS", "JS"],
//     sourceCode: "https://github.com/Aditya-devp/Sortify",
//   },
// ];

// const skills = [

//   'C',
//   'C++',
//   'Java',
//   'Python',
//   'HTML',
//   'CSS',
//   'JavaScript',
//   'TypeScript',
//   'Node.js',
//   'Express.js',
//   'React',
//   'Material UI',
//   'MongoDB',
//   'Git',
//   'Github',

// ]

// const contact = {

//   email: 'singhaditya6774@mail.com',
// }

// export { header, about, projects, skills, contact }

const header = {};

const about = {
  name: "Aditya Singh",
  role: "Aspiring Software Developer",
  description: "",
  resume:
    "https://drive.google.com/file/d/1RZTnn2au_hia-3xC2cqu4dUE0fz9l5Kt/view?usp=sharing",
  social: {
    linkedin: "https://www.linkedin.com/in/aditya-singh-97396a21a/",
    github: "https://github.com/Aditya-devp",
    twitter:
      "https://twitter.com/AdityaS48654968?t=LxdOQmRtW6XlmeOOlZMFpg&s=08",
  },
};

const projects = [
  {
    name: "Conversa",
    description:
      "Conversa Conversa is a real-time chat application that facilitates instant communication between users.It provide a seamless and interactive messaging experience.",
    stack: ["Node.js", "Express", "MongoDB", "React"],
    sourceCode: "https://github.com/Aditya-devp/Conversa",
  },
  {
    name: "BlogBreeze",
    description:
      "BlogBreeze BlogBreeze is a dynamic blog application that allows users to create and share blogs with ease. Users can engage with content by posting comments and exploring blogs through various categories, making it simple to find topics of interest.",
    stack: ["Node.js", "Express", "MongoDB", "React"],
    sourceCode: "https://github.com/Aditya-devp/BlogBreeze",
  },
  {
    name: "Sortify",
    description:
      "Sortify is a web-based sorting visualizer that allows users to interactively visualize various sorting algorithms. This project aims to provide a hands-on learning experience for understanding how different sorting algorithms work.",
    stack: ["HTML", "CSS", "JS"],
    sourceCode: "https://github.com/Aditya-devp/Sortify",
  },
];

const skills = [
  "C",
  "C++",
  "Java",
  "Python",
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "Node.js",
  "Express.js",
  "React",
  "Material UI",
  "MongoDB",
  "Git",
  "Github",
];

const contact = {
  email: "singhaditya6774@mail.com",
};

export { header, about, projects, skills, contact };
